import script from "./TicketIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./TicketIndex.vue?vue&type=script&setup=true&lang=js"

import "./TicketIndex.vue?vue&type=style&index=0&id=670fa51c&lang=css"

const __exports__ = script;

export default __exports__